<template>
    <div class="serviceDetailContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>服务详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 商品信息 -->
        <div class="detailBox spb">
            <div class="detailImgBox">
                <el-image v-if="serviceDetailData.goods_img" :src="serviceDetailData.goods_img" fit="contain" class="detailImg"></el-image>
            </div>
            <div class="detailData">
                <div class="title">{{ serviceDetailData.goods_name }}</div>
                <div class="introduce">{{ serviceDetailData.goods_name1 }}</div>
                <div class="specBox flex">
                    <div class="specTitle">规格</div>
                    <div class="specList flex">
                        <div :class="['spec',serviceDetailData.active == index ? 'specOn' : '']" v-for="(item,index) in serviceDetailData.spec" @click="serviceDetailData.active = index">{{ item.spec_name }}</div>
                    </div>
                </div>
                <div class="priceBox align">
                    <div class="priceTitle">参考价格</div>
                    <div class="price"><span>￥</span>{{ serviceDetailData.spec.length > 0 ? serviceDetailData.spec[serviceDetailData.active].sale_price : serviceDetailData.sale_price }}</div>
                </div>
                <div class="detailBtn" @click="detailBtnTap">立即使用</div>
            </div>
            <div class="storeData">
                <div class="storeTitle">服务商信息</div>
                <div class="storeTips">通过AI智能筛选本服务由:</div>
                <div class="center">
                    <div class="storeName">{{ serviceDetailData.provide }}</div>
                </div>
                <!-- <div class="mortgageBox center">
                    <el-image :src="require('@/assets/icon/mortgage.png')" fit="cover" class="mortgageIcon"></el-image>
                    <div class="mortgageNum">保证金: {{ serviceDetailData.bond_price }}元</div>
                </div> -->
            </div>
        </div>
        <!-- 详情图 -->
        <div class="courseBox">
            <div class="courseTabBox align">
                <div :class="['courseTab',active == index ? 'courseTabOn' : '']" v-for="(item,index) in courseTabData" :key="index" @click="courseTabTap(index)">{{ item }}</div>
            </div>
            <div class="courseImgBox">
                <div v-html="active == '0' ? serviceDetailData.success : active == '1' ? serviceDetailData.detail : ''"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                userDetail: 0,
                serviceDetailData: {},
                active: 0,
                courseTabData: ['成功方案','服务详情'],
            }
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getGoodsDetail()
        },
        methods: {
            // 获取商品详情
            getGoodsDetail(){
                this.request.get("index/fuwu/detail",{
                    params:{
                        id: this.$route.query.id
                    }
                })
                .then(res=>{
                    res.data.active = 0
                    this.serviceDetailData = res.data
                })
            },
            // tab切换
            courseTabTap(e){
                this.active = e
                console.log(this.$route.params.id)
            },
            // 跳转提交表单
            detailBtnTap(){
                if(!this.userDetail){
                    this.$router.push({ path:'/login/login' })
                    return
                }
                this.$router.push({ path:'/service/form', query:{id:this.$route.query.id,type: '2',specId:this.serviceDetailData.spec.length > 0 ? this.serviceDetailData.spec[this.serviceDetailData.active].id : 0} })
            }
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/detail.less';
</style>